// components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-center lg:w-full  p-4 text-white">
      <p>© 2024 Vilas K Lamani - React Developer</p>
    </footer>
  );
}

export default Footer;
